const r = (n, e) => e.length ? e.some((t) => n.includes(t) || !1) : !0;
export {
  r as glsHasAnyRole
};
